import { useEffect } from 'react';
import { actions } from '../store';
import { Theme } from '../TeamsProvider';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router';
import { routerActions } from 'connected-react-router';
import { RouteComponentProps } from 'react-router-dom';

function isTheme(value: Theme) {
  return ['light', 'dark', 'contrast', 'red', 'red2', 'blue', 'darkblue', 'smokeblue', 'gold', 'green', 'orange', 'teal', 'violet', 'lime'].includes(value.toLowerCase())
}

export default function AchieveApi(props: RouteComponentProps) {
  const dispatch = useDispatch();
  const isAchieveVm = useRouteMatch('/achievevm');
  const queryParams = new URLSearchParams(props.location.search);
  const darkMode = queryParams.get('dark');
  const theme = queryParams.get('theme');
  const extension = queryParams.get('extension');

  useEffect(() => {
    // Update dark mode attribute
    if (darkMode) {
      const bodyRoot = document.getElementById('body-root');
      if (bodyRoot) {
        bodyRoot.setAttribute('data-darkMode', darkMode);
      }
    }

    // Dispatch Redux actions
    if (isTheme(theme as Theme)) {
      dispatch(actions.setAchieve(true));
      dispatch(actions.setTheme(theme as Theme));
      dispatch(actions.setWebRtcEnabled(false));
      dispatch(actions.instantMessagerSettingsSet(false, undefined, undefined));
    } else {
      dispatch(actions.setTheme('light'));
    }

    // Redirect based on conditions
    if (isAchieveVm) {
      dispatch(routerActions.replace('/vm'));
    } else if (extension) {
      dispatch(routerActions.replace(`/achieveextension/${extension}`));
    } else {
      dispatch(routerActions.replace('/'));
    }
  }, [darkMode, theme, extension, isAchieveVm, dispatch]);

  return null;
}
